const copyTableToClipboard = (tableId) => {
  const table = document.getElementById(tableId);  // テーブルのIDを指定
  console.log(table);
  let tableData = '';
  
  // テーブルの行をループして、テキストとして出力
  for (let row of table.rows) {
    let rowData = [];
    for (let cell of row.cells) {
      rowData.push(cell.innerText);
    }
    tableData += rowData.join('\t') + '\n'; // タブ区切りで行をつなげる
  }
  
  // クリップボードにコピー
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(tableData).then(() => {
      alert('テーブルのデータがクリップボードにコピーされました');
    }).catch(err => {
      console.error('コピー失敗:', err);
    });
  } else {
    alert('クリップボードAPIはサポートされていません');
  }
};

export default copyTableToClipboard